import BaseController from "confinus_ui/base_controller";
import { showModal } from "lib/overlay/modal";
import { markAsSafeHTML } from "lib/util/safe_html";

export default class ProductLightboxController extends BaseController {
  public static values = {
    contentHref: { type: String, default: null },
    placeholder: { type: String, default: null },
  };

  declare private readonly contentHrefValue: string;
  declare private readonly placeholderValue: string;
  public handleButtonClick(evt: Event) {
    // Stop propagation: prevent any clicks leaking out
    evt.preventDefault();
    evt.stopPropagation();

    // Show the dialog
    showModal({
      closeOnOverlayClick: true,
      contentHref: this.contentHrefValue,
      placeholder: markAsSafeHTML(this.placeholderValue),
    });
  }
}
